import { render } from "./VerticalDivider.vue?vue&type=template&id=3d4e5d22&scoped=true"
import script from "./VerticalDivider.vue?vue&type=script&lang=js"
export * from "./VerticalDivider.vue?vue&type=script&lang=js"

import "./VerticalDivider.vue?vue&type=style&index=0&id=3d4e5d22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4e5d22"]])

export default __exports__